//sbensouda: please do not change production value!!!!
const baseURL = "https://api.lecket.gm";
// const baseURL = "http://192.168.2.41:3004";
export default baseURL;
